<template>
  <v-data-table :headers="headers" :items="filteredAppraisals" sort-by="title">
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          label="Busca"
          v-model="filter"
          outlined
          dense
          hide-details
          clearable
          append-icon="eva-search-outline"
        />

        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" fullscreen @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Novo laudo
            </v-btn>
          </template>

          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="close">
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

              <v-spacer />

              <v-toolbar-items>
                <v-btn dark text @click="save"> Salvar </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-container fluid>
              <v-row dense>
                <v-col cols="7">
                  <v-text-field
                    outlined
                    dense
                    v-model="editedItem.title"
                    label="Texto"
                    :hide-details="!errors.editedItem"
                    :error-messages="errors.editedItem"
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <RichText v-model="editedItem.description" />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_appraisal"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_appraisal"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há laudos cadastrados
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "AppraisalList",
  props: {
    examTemplate: Object,
  },
  data() {
    return {
      errors: {},
      dialog: null,
      editedItem: {},
      editedIndex: -1,
      filter: "",
      headers: [
        { text: "Titulo ", value: "title" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
    };
  },

  apollo: {
    examAppraisals: {
      query: require("@/graphql/appraisal/exam_appraisals.gql"),
      variables() {
        return {
          examTemplateId: this.examTemplate.id,
        };
      },
      pollInterva: 2000,
    },
  },
  computed: {
    filteredAppraisals() {
      let appraisals = this.examAppraisals;

      if (this.filter) {
        appraisals = this.lodash.filter(
          appraisals,
          function (e) {
            return e.title
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return appraisals;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Novo laudo" : "Editar laudo";
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.filteredAppraisals.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Você realmente deseja deletar esse laudo?")) {
        this.apolloMutate({
          mutation: require("@/graphql/appraisal/delete_appraisal.gql"),
          variables: {
            examAppraisalId: item.id,
          },
        }).then(() => {
          this.refreshList();
          this.$store.dispatch("createNotification", {
            message: "Facilitador deletado com sucesso.",
            type: "success",
          });
        });
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (!this.validate()) return;

      this.apolloMutate({
        mutation: require("@/graphql/appraisal/save_appraisal.gql"),
        variables: {
          examAppraisalId: this.lodash.get(this.editedItem, "id", ""),
          examTemplateId: this.examTemplate.id,
          title: this.editedItem.title,
          description: this.editedItem.description,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    refreshList() {
      return this.$apollo.queries.examAppraisals.refetch();
    },
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      let title = this.editedItem.title;
      if (this.lodash.isEmpty(title?.trim())) {
        this.errors.editedItem = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
